import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAvailablePhoneNumbers,
    GetAvailablePhoneNumbersVariables,
} from 'nutshell-graphql-types';

import GET_AVAILABLE_PHONE_NUMBERS from '../queries/get-available-phone-numbers.graphql';

export const useGetAvailablePhoneNumbers = (areaCode: number) => {
    const {
        data,
        error,
        loading: isLoading,
        refetch,
    } = useQuery<GetAvailablePhoneNumbers, GetAvailablePhoneNumbersVariables>(
        GET_AVAILABLE_PHONE_NUMBERS,
        {
            variables: {
                areaCode,
            },
            // we pass skip: true to prevent the query from running until the button is clicked
            skip: true,
        }
    );

    const availablePhoneNumbers = data ? data.availablePhoneNumbers : null;

    return {
        availablePhoneNumbers,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
    };
};
